import { Container } from 'inversify';

export const myContainer = new Container();
